<script lang="ts">
	import StarRating from './StarRating.svelte'
	import type { PublicReviewFieldsFragment } from '$src/lib/queries/fragments/generated/ReviewFields'
	import { formatDate } from '$src/lib/utils/date-helpers'
	import { browser } from '$app/environment'
	import { sanitizeHtml } from '$src/lib/utils/sanitize'

	interface Props {
		review: PublicReviewFieldsFragment
	}

	let { review }: Props = $props()

	let computedSrc = $state(review?.reviewer?.currentProfilePictureUrl)
	function handleImageLoadError() {
		computedSrc = '/visuals/icons/default-user.svg'
	}

	let displayName = $derived(
		review.reviewer.currentName || review.reviewer.username || 'Anonymous User',
	)

	let sanitizedFeedback = $state('')
	let sanitizedComment = $state('')

	$effect(() => {
		if (!browser || !(review.feedbackToCreator || review.comment)) return

		let cancelled = false
		try {
			if (review.feedbackToCreator) {
				sanitizeHtml(review.feedbackToCreator, browser, (result) => {
					if (!cancelled) {
						sanitizedFeedback = result
					}
				})
			}
			if (review.comment) {
				sanitizeHtml(review.comment, browser, (result) => {
					if (!cancelled) {
						sanitizedComment = result
					}
				})
			}
		} catch (error) {
			console.error('Error sanitizing content:', error)
			sanitizedFeedback = review.feedbackToCreator ?? ''
			sanitizedComment = review.comment ?? ''
		}
		return () => {
			cancelled = true
		}
	})
</script>

<div class="px-1 my-6 flex items-start space-x-3 w-full">
	<img
		src={computedSrc}
		alt=""
		width="36"
		height="36"
		loading="lazy"
		class="h-9 w-9 rounded-full bg-brand-gray-2"
		onerror={handleImageLoadError}
	/>
	<div class="text-sm w-full">
		<div class="flex items-center justify-between gap-x-2 w-full">
			<div class="font-medium text-brand-gray-1">{displayName}</div>
			<p class="text-xs">
				<time dateTime={review?.createdAt}>{formatDate(review?.createdAt)}</time>
			</p>
		</div>
		<StarRating value={review?.starRating} readonly={true} />
		<p class="mt-4 text-xs text-brand-gray-3">{@html review?.feedbackToCreator}</p>

		{#if review?.comment}
			<p class="mt-4 text-xs font-medium text-brand-gray-1">Comment from Creator</p>
			<p class="mt-1 text-xs text-brand-gray-3">{@html review?.comment}</p>
		{/if}
	</div>
</div>
